import { render, staticRenderFns } from "./debug_tab_ancillaries.vue?vue&type=template&id=125d013a&scoped=true&"
import script from "./debug_tab_ancillaries.vue?vue&type=script&lang=js&"
export * from "./debug_tab_ancillaries.vue?vue&type=script&lang=js&"
import style0 from "./debug_tab_ancillaries.vue?vue&type=style&index=0&id=125d013a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125d013a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/deploy/beta-web-new/web_head/releases/20260225113833/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('125d013a')) {
      api.createRecord('125d013a', component.options)
    } else {
      api.reload('125d013a', component.options)
    }
    module.hot.accept("./debug_tab_ancillaries.vue?vue&type=template&id=125d013a&scoped=true&", function () {
      api.rerender('125d013a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/desktop/debug/debug_tab_ancillaries.vue"
export default component.exports